/* eslint-disable react/display-name */
import { RootState } from "interfaces/generics.type";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDeviceWidth } from "../action/utils/setDeviceWidth";
import { logPageView } from "./activitywatcher";

function WindowResizeListener(props: any) {
  const dispatch = useDispatch();
  const router = useRouter();

  const width = useSelector((state: RootState) => state.utils.width);
  useEffect(() => {
    // Log Page View, for server side rendered page.
    const { asPath } = router;
    logPageView(
      asPath,
      window.document.referrer,
      true,
    );

    function handleResize() {
      if (width !== window.innerWidth) {
        dispatch(setDeviceWidth(window.innerWidth));
      }
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return props.children;
}

const WindowResizeListenerWrapper = WindowResizeListener;

function withWindowResizeListener(WrappedComponent: any) {
  return function (props: any) {
    return (
      <WindowResizeListenerWrapper>

        <WrappedComponent {...props} />
      </WindowResizeListenerWrapper>
    );
  };
}

export default withWindowResizeListener;
